import { langStore } from "@/stores/lang-store"

const DetailGrid = ({ title, headers = [], data }) => {
  const { lang } = langStore()

  return (
    <div className="my-5">
      <h3 className="font-semibold text-lg mb-2">{title}</h3>

      {/* Desktop */}
      <div
        className="hidden md:grid text-center"
        style={{ gridTemplateColumns: `1.5fr repeat(${headers.length - 1}, 1fr)` }}
      >
        {headers.map((item) => (
          <div key={item.key} className="py-1 font-semibold bg-count-total text-white">
            {item.label[lang]}
          </div>
        ))}

        {headers.map((item) => (
          <div key={item.key} className="py-2 border-b text-sm">
            {data[item.key] ?? "-"}
          </div>
        ))}
      </div>

      {/* Mobile */}
      <div className="md:hidden space-y-2">
        {headers.map((item) => (
          <div
            key={item.key}
            className="flex justify-between gap-4 px-3 py-2 bg-gray-50 rounded-lg"
          >
            <div className="text-sm text-gray-500">{item.label[lang]}</div>
            <div className="text-sm font-medium text-gray-900 text-right">
              {data[item.key] ?? "-"}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default DetailGrid
